import { c as _c } from "react/compiler-runtime";
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ContentText } from './components/ContentText';
import { RewardsRateContainer } from './RewardsRate.container';
export function RewardsRate() {
  const $ = _c(2);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    rewardRateNotes
  } = t0;
  let t1;
  if ($[0] !== rewardRateNotes) {
    t1 = <RewardsRateContainer><ContentText>{rewardRateNotes}</ContentText></RewardsRateContainer>;
    $[0] = rewardRateNotes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}